import { useState, useEffect, useRef } from "react";
import "./rectangleCardTim4.css";

function RectangleCardTim4({
    deviceName,
    deviceId,
    markerId = "000",
    productId,
    setUpDevice,
    onClick,
    calSetUp,
    calibrationStatus,
    setUpStatus,
    instalationStatus,
    tabInd,
    retest,
    onResetClick,
    onDebugClick,
}) {
    const [calibrationStatusText, setCalibrationStatusText] = useState({});
    const [buttonOnClick, setButtonOnClick] = useState(2);
    const ref = useRef();

    console.log(productId);
    useEffect(() => {
        function checkStatus() {
            if (instalationStatus > 0) {
                if (instalationStatus === 1) {
                    setCalibrationStatusText({ text: "Test Passed", background: "#29CF81", type: "span" });
                    setButtonOnClick(2);
                } else if (instalationStatus === 2) {
                    setCalibrationStatusText({ text: "Partial Passed", background: "#29CF81", type: "span" });
                    setButtonOnClick(2);
                } else if (instalationStatus === 3) {
                    setCalibrationStatusText({ text: "Test Failed", background: "#F65162", type: "span" });
                    setButtonOnClick(2);
                } else {
                    setCalibrationStatusText({ text: "Test Error", background: "#F65162", type: "span" });
                    setButtonOnClick(2);
                }
            } else {
                if (setUpStatus === 0) {
                    setCalibrationStatusText({ text: "Set-up", background: "transparent", type: "button" });
                    setButtonOnClick(1);
                } else if (setUpStatus === 1 && calSetUp === 2 && calibrationStatus === 0) {
                    setCalibrationStatusText({ text: "Set-up done", background: "#29CF81", type: "span" });
                    setButtonOnClick(2);
                } else if (setUpStatus === 1 && calSetUp === 2 && calibrationStatus === 1) {
                    setCalibrationStatusText({ text: "Tim Offline", background: "#BBBBBB", type: "span" });
                    setButtonOnClick(2);
                } else if (setUpStatus === 1 && calSetUp === 2 && calibrationStatus === 2) {
                    setCalibrationStatusText({ text: "Not Detected", background: "#F65162", type: "span" });
                    setButtonOnClick(2);
                } else if (setUpStatus === 1 && calSetUp === 3 && calibrationStatus === 3) {
                    setCalibrationStatusText({ text: "Test", background: "transparent", type: "button" });
                    setButtonOnClick(1);
                } else {
                    setCalibrationStatusText({ text: "Error", background: "#F65162", type: "span" });
                }
            }
        }
        checkStatus();
    }, [setUpStatus, calSetUp, calibrationStatus, instalationStatus]);

    useEffect(() => {
        if (ref.current && tabInd) ref.current.blur();
    }, [tabInd]);

    function productTypeFromProductID(id) {
        console.log(id);
        switch (id) {
            case "6875f0bf-157d-332e-883f-70e58401dd14": return "TIM";
            case "62d3da73-debf-8660-5fb4-f5d6c646358f": return "TIM+";
            case "2d5ef6ed-051c-0bb9-70a4-718d31215e0e": return "FLO";
            case "9c6047be-d288-4faa-8a2a-5f595f4fd339": return "TIM-4";
            case "cb1a34bf-e4ea-a74b-d496-37c1183ffa97": return "BAT-TIM";
            case "4b357a17-cc2d-5d63-116f-a539a78a2802": return "POE TIM+";
            case "6a36e934-426c-025f-a025-89bed058974d": return "POE TIM";
            case "85939db1-afba-b79e-b424-2e295ec2a9b5": return "POE FLO";
            default: return "--";
        }
    }

    // "Set-up done" = setup_status:1, cal_status:2, calibration_status:0
    // Debug is only relevant before calibration is triggered (cal_status < 3)
    const isSetUpDone = setUpStatus === 1 && calSetUp === 2 && calibrationStatus === 0;
    const showDebug = isSetUpDone && !!onDebugClick;
    const showReset = setUpStatus > 0 && !!onResetClick;
    const showActionButtons = showDebug || showReset;

    return (
        <div
            className="rectangle-card-tim4-body p-3 my-3"
            onClick={onClick}
            style={{ cursor: "pointer" }}
        >
            <div className="rectangle-card-tim4-body-top">
                <span className="rectangle-card-tim4-body-top-content1">{deviceName}</span>
                <div style={{ display: 'flex', gap: '0.4rem', alignItems: 'center' }}>
                    {showDebug && (
                        <button
                            tabIndex={tabInd ? -1 : 0}
                            className="buttonStandard2"
                            onClick={(e) => { e.stopPropagation(); onDebugClick(); }}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); onDebugClick(); } }}
                        >
                            Debug
                        </button>
                    )}
                    {retest && (
                        <button
                            ref={ref}
                            tabIndex={tabInd ? -1 : 0}
                            className="buttonStandard2"
                            onClick={(e) => { e.stopPropagation(); retest(e); }}
                        >
                            Retest
                        </button>
                    )}
                    {calibrationStatusText.type === "button" ? (
                        <button
                            ref={ref}
                            tabIndex={tabInd ? -1 : 0}
                            className="buttonStandard2"
                            onClick={(e) => { e.stopPropagation(); setUpDevice(e); }}
                        >
                            {calibrationStatusText.text}
                        </button>
                    ) : (
                        <span
                            className="rectangle-card-tim4-body-top-content1-setUp-done"
                            style={{ background: calibrationStatusText.background }}
                        >
                            {calibrationStatusText.text}
                        </span>
                    )}
                </div>
            </div>

            <div className="rectangle-card-tim4-body-bottom" style={{ marginTop: '0.4rem' }}>
                <span style={{ fontWeight: "700" }}>Product Type: {productTypeFromProductID(productId)}</span>
                <span>Device ID:   {deviceId}</span>
                <span>Marker ID:  {markerId}</span>
            </div>

            {showReset && (
                <div className="rectangle-card-tim4-body-actions">
                    <button
                        tabIndex={tabInd ? -1 : 0}
                        className="buttonStandard2"
                        onClick={(e) => { e.stopPropagation(); onResetClick(); }}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); onResetClick(); } }}
                    >
                        Reset
                    </button>
                </div>
            )}
        </div>
    );
}

export default RectangleCardTim4;
